<template>
    <loading v-if="loading"></loading>
    <v-layout v-else column>
        <v-radio-group v-model="displayValueTypeCode" row class="align-center justify-center">
            <v-radio v-for="(valueTypeCode, i) in valueTypeCodes" :key="`valueTypeCode${i}`" :label="valueTypeCode.text" :value="valueTypeCode.value"></v-radio>
        </v-radio-group>
        <v-layout row wrap align-center justify-space-around>
            <v-flex v-for="(selectedProfile, i) in selectedProfiles" :key="`cropProfileGraph${i}`" xs12 :sm6="selectedProfiles.length > 1" :lg4="selectedProfiles.length > 2" px-1>
                <crop-profile-graph ref="cropProfileGraph"
                    :financialYearCalendars="financialYearCalendars"
                    :cropProfile="selectedProfile"
                    :cropForecasts="cropForecasts"                    
                    :displayValueTypeCode="displayValueTypeCode"
                    :loading="graphLoading">
                </crop-profile-graph>
            </v-flex>
        </v-layout>
        <forecast-profiles
            :financialYearCalendars="financialYearCalendars"
            :forecastProfiles="forecastProfiles" 
            :cropLocationID="cropLocationID"            
            :showOfflineWarning="networkStatusOffline"
            :selectedProfiles="selectedProfiles"
            :crop="crop"
            @onProfileIDSelected="onProfileIDSelected">
        </forecast-profiles>
    </v-layout>
</template>

<script>
import CropProfileGraph from '@/components/crops/CropProfileGraph.vue';
import ForecastProfiles from '@/components/forecasting/ForecastProfiles.vue';
import Loading from '@/components/generic/Loading.vue';
import forecastingService from '@/services/forecastingService';
import forecastingUtilService from '@/services/forecastingUtilService';

export default {
    components: {
        CropProfileGraph,
        ForecastProfiles,
        Loading
    },
    props: [
        'cropLocationID',        
        'defaultValueTypeCode',
        'crop'
    ],
    data(){
        return {            
            loading: false,
            graphLoading: false,
            error: null,
            displayValueTypeCode: (this.defaultValueTypeCode == null ? "%" : this.defaultValueTypeCode),
            financialYearCalendars : null,
            valueTypeCodes: [
                {
                    text: "Percentage (%)",
                    value: "%"
                }, 
                {
                    text: "Kilograms (kg)",
                    value: "kg"
                }
            ],
            selectedProfiles: []
        };
    },
    watch: {
        cropProfiles() {
            this.updateSelectedProfiles(this.cropProfiles.filter(p => this.selectedProfiles.some(s => s.BerriesForecastProfileID == p.BerriesForecastProfileID)));
        }
    },
    computed: {
        forecastProfiles(){
            return this.cropProfiles.concat(this.globalProfiles);
        },
        cropProfiles(){
            return this.$store.getters["ForecastingProfileStore/getForecastProfiles"]({
                cropLocationID: this.cropLocationID
            });
        },
        cropForecasts() {
            return this.$store.getters["ForecastingProfileStore/getForecasts"]({
                cropLocationID: this.cropLocationID
            });
        },
        globalProfiles(){
            return this.$store.getters["ForecastingProfileStore/getForecastProfiles"]({
                cropLocationID: null
            });
        },
        networkStatusOffline(){
            return this.$store.getters["ForecastingProfileStore/getNetworkError"];
        }
    },
    methods: {
        async init(){            
            await this.loadCropProfiles();            
        },
        async loadCropProfiles(){
            if(this.loading) {
                return;
            }

            this.loading = true;

            await this.$store.dispatch("ForecastingProfileStore/loadCropForecastProfilesAsync", {
                    cropLocationID: this.cropLocationID
                });

            this.financialYearCalendars = await forecastingService.getFinancialYearCalendarsData();

            this.loading = false;
        },
        async onProfileIDSelected(profileID){
            if(this.graphLoading) {
                return;
            }

            // If this profile is already selected, toggle it off
            if(this.selectedProfiles.some(x => x.BerriesForecastProfileID == profileID)){
                // Updated selection excludes selected profile
                this.updateSelectedProfiles([
                    ...this.selectedProfiles.filter(x => x.BerriesForecastProfileID != profileID)
                ]);
                return;
            }

            this.graphLoading = true;

            // Otherwise, toggle it on
            let cropProfile = this.cropProfiles.find(x => x.BerriesForecastProfileID == profileID);

            this.updateSelectedProfiles([
                ...this.selectedProfiles, cropProfile
            ]);

            let startDate = forecastingUtilService.getFinancialStartDateFromProfile(cropProfile, this.financialYearCalendars);
            let endDate = forecastingUtilService.getFinancialEndDateFromProfile(cropProfile, this.financialYearCalendars);

            await this.$store.dispatch("ForecastingProfileStore/loadCropForecastsAsync", {
                cropLocationID: cropProfile.CropLocationID,
                varietyID: cropProfile.Variety.VarietyID,
                startDate: startDate,
                endDate: endDate
            });

            this.graphLoading = false;
        },
        updateSelectedProfiles(newSelectedProfiles){
            this.selectedProfiles.splice(0, this.selectedProfiles.length, ...newSelectedProfiles);

            // Re-render graphs to take up new amount of space
            this.$nextTick(() => this.renderCharts());
        },
        renderCharts(){
            if(this.$refs.cropProfileGraph == null){
                return;
            }
            
            this.$refs.cropProfileGraph.forEach(x => x.render());
        }
    },
    created(){
        this.init();
    }
}
</script>

<style scoped>

</style>
